// The backend always stores/returns alarmIntervalSeconds; units here are display/input only.
export const ALARM_INTERVAL_UNITS = [
  { value: 'days', label: 'Days', seconds: 86400, suffix: 'd' },
  { value: 'hours', label: 'Hours', seconds: 3600, suffix: 'h' },
  { value: 'minutes', label: 'Minutes', seconds: 60, suffix: 'min' },
  { value: 'seconds', label: 'Seconds', seconds: 1, suffix: 's' },
];

export const DEFAULT_ALARM_INTERVAL_UNIT = 'days';

export const alarmIntervalToSeconds = (value, unit) => {
  const selectedUnit = ALARM_INTERVAL_UNITS.find(u => u.value === unit);
  const unitSeconds = selectedUnit ? selectedUnit.seconds : 1;
  const seconds = (Number(value) || 0) * unitSeconds;
  return Math.round(seconds) / unitSeconds === Number(value) ? Math.round(seconds) : seconds;
};

// Largest unit the value divides into evenly, so 86400 reads as days rather than seconds.
const pickUnit = totalSeconds =>
  ALARM_INTERVAL_UNITS.find(unit => totalSeconds >= unit.seconds && totalSeconds % unit.seconds === 0)
    || ALARM_INTERVAL_UNITS.find(unit => unit.value === 'seconds');

export const formatAlarmInterval = seconds => {
  const totalSeconds = Number(seconds) || 0;
  const unit = pickUnit(totalSeconds);

  return `${totalSeconds / unit.seconds}${unit.suffix}`;
};

export const splitAlarmInterval = seconds => {
  const totalSeconds = Number(seconds) || 0;
  const unit = pickUnit(totalSeconds);

  return { value: totalSeconds / unit.seconds, unit: unit.value };
};
